/**
 * Fold champion-title punctuation so official errata names ("Janna, Savior")
 * match catalog names ("Janna - Savior"). Keep aligned with
 * `api/_shared/cardNameNormalize.js` (`foldCardNameForMatch`).
 */
export function foldCardNameForMatch(name: string): string {
  return (name ?? '')
    .toLowerCase()
    .replace(/\uFF08/g, '(')
    .replace(/\uFF09/g, ')')
    .replace(
      /[\u2010\u2011\u2012\u2013\u2014\u2015\u2212\uFE31\uFE32\uFE58\uFE63\uFF0D]/g,
      '-',
    )
    .replace(/['']/g, "'")
    .replace(/[""]/g, '"')
    .replace(/\s*,\s*/g, '-')
    .replace(/\s*-\s*/g, '-')
    .replace(/\s+/g, ' ')
    .trim();
}
